module.exports = __webpack_public_path__ + "static/media/outside3.13f0594a.png";